import React, { useEffect, useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, message, Empty } from 'antd'
// Layout
import { Sidebar } from '../Layout/Sidebar'
// Fragments
import { Header } from '../Fragments/Users/Header'
import { ContentDetails } from '../Fragments/Users/ContentDetails'
import { ContentUsers } from '../Fragments/Users/ContentUsers'
// i18
import { useTranslation } from 'react-i18next'
// Axios
import axios from 'axios'
// Config
import config from '../config'

export const Users = () => {
    
    const { t } = useTranslation(["translation"])
    const [messageApi, contextHolder] = message.useMessage()
    const navigate = useNavigate()

    const [select, setSelect] = useState({})
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [isCreated, setIsCreated] = useState(false)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)

    const getUsers = async() => {
        var pageNew = 0
        if(page <= 0) {
            pageNew = 0
        }
        else {
            pageNew = (page*10)-10
        }

        setLoading(true)
        try {
            const res = await axios.get(`${config.urlApi}/private/users?skip=${pageNew}`, {
                withCredentials: true,
            })
            if(res.status === 200) {
                setData(res.data.data.users)
                setTotal(res.data.data.total)
                setLoading(false)
            }
        }
        catch (error) {
            setLoading(false)

            if(error.status===401) {
                messageApi.error(t("error_user"))
            }
            else if (error.status===401) {
                navigate("/")
            }
            else if(error.status===404) {
                return
            }
            else {
                messageApi.error(t("error_server"))
            }
        }
    }
    useEffect(() => {
        getUsers()

        const isAlert = localStorage.getItem("deleteUser")
        if(isAlert) {
            messageApi.success(t("user_delete"))
            localStorage.removeItem("deleteUser")
        }

        const isUpdate = localStorage.getItem("updateUser")
        if(isUpdate) {
            messageApi.success(t("user_update"))
            localStorage.removeItem("updateUser")
        }
    }, [isCreated, page])
    
    return (
        <Flex>
            <Sidebar />

            <Flex vertical style={{ width: "calc(100% - 250px)", height: "100vh", padding: "0 15px" }}>
                <Header t={t} isCreated={isCreated} setIsCreated={setIsCreated} />
                
                {(data.length === 0 && !loading)
                    ?
                    <Flex justify="center" style={{ width: "100%", marginTop: "10px" }}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("empty_users")} />
                    </Flex>
                    :
                    <Flex>
                        <ContentUsers select={select} data={data} loading={loading} setSelect={setSelect} page={page} setPage={setPage} total={total} />
                        <ContentDetails t={t} select={select} setSelect={setSelect} isCreated={isCreated} setIsCreated={setIsCreated} />
                    </Flex>
                }
            </Flex>

            {contextHolder}
        </Flex>
    )
}
